import { useState } from "react";
import { normalizeBackendFileUrl } from "../../utils/backendApi";
import {
  Card,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Form,
  Spinner,
} from "reactstrap";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Loader from "../../Components/Common/Loader";
import {
  usePublishRecruitment,
  useRecruitment,
} from "../../hooks/useRecruitments";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import classnames from "classnames";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import SwiperCore, { FreeMode, Navigation, Thumbs } from "swiper";
import { useHistory, useParams } from "react-router-dom";
import defaultIllustration from "../../assets/images/lcbtp.png";

SwiperCore.use([FreeMode, Navigation, Thumbs]);

function RecrutementsDetail(props) {
  const history = useHistory();
  const { id } = useParams();

  const {
    data: selectAticle = {},
    isLoading,
    isError,
    error,
  } = useRecruitment(id);

  const publishMutation = usePublishRecruitment();

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {},
    onSubmit: () => {
      publishMutation.mutate(id, {
        onSuccess: () => {
          validation.resetForm();
          history.push("/recruitments");
        },
      });
    },
  });

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return (
      <Loader error={error?.message || props.t("Erreur lors du chargement")} />
    );
  }

  document.title = props.t("Détail d'une offre d'emploi");
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={props.t("Détail d'une offre d'emploi")}
          pageTitle={props.t("Offre d'emploi")}
        />
        <Row>
          <Col lg={12}>
            <Card className="px-2 pb-4">
              <Row className="gx-lg-5">
                <Col xl={12}>
                  <div className="mt-xl-0 mt-5">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={selectAticle.offer_pic || defaultIllustration}
                        alt={props.t("Illustration")}
                        className="rounded"
                        style={{
                          height: "auto",
                          width: "auto",
                          maxHeight: "80%",
                          maxWidth: "80%",
                          marginTop: "20px",
                        }}
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = defaultIllustration;
                        }}
                      />
                    </div>

                    <div className="d-flex">
                      <div className="flex-wrap gap-3">
                        <br></br>
                        <h2>
                          {" "}
                          {"#"}
                          {selectAticle.reference} : {selectAticle.title}
                          <span className="text-xl fw-medium me-1">
                            &nbsp;&nbsp;
                            {new Date() >
                            new Date(selectAticle.closure_date) ? (
                              <h5
                                className="fs-14 mb-1 badge badge-soft-danger text-xs"
                                style={{ textAlign: "center" }}
                              >
                                {"Cloturé"}
                              </h5>
                            ) : (
                              <h5
                                className="fs-14 mb-1 badge badge-soft-success text-xs me-1 "
                                style={{ textAlign: "center" }}
                              >
                                {"En cours"}
                              </h5>
                            )}
                          </span>
                          <span className="text-xl fw-medium me-1">
                            &nbsp;&nbsp;
                            {selectAticle &&
                            selectAticle.offer_type === "job" ? (
                              <h5
                                className="fs-14 mb-1 badge badge-soft-warning text-xs"
                                style={{ textAlign: "center" }}
                              >
                                {"Offre d'emploi"}
                              </h5>
                            ) : (
                              ""
                            )}
                          </span>
                        </h2>
                      </div>
                    </div>
                    <div
                      className="m-4 text-muted"
                      style={{ textAlign: "justify" }}
                    >
                      <p>{selectAticle.description}</p>
                    </div>

                    <div className="product-content mt-5">
                      <Nav tabs className="nav-tabs-custom nav-success">
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: customActiveTab === "1",
                            })}
                            onClick={() => {
                              toggleCustom("1");
                            }}
                          >
                            {props.t("Détails")}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: customActiveTab === "2",
                            })}
                            onClick={() => {
                              toggleCustom("2");
                            }}
                          >
                            {props.t("Autres informations")}
                          </NavLink>
                        </NavItem>
                      </Nav>

                      <TabContent
                        activeTab={customActiveTab}
                        className="border border-top-0 p-4"
                        id="nav-tabContent"
                      >
                        <TabPane id="nav-speci" tabId="1">
                          <div className="table-responsive">
                            <table className="table mb-0">
                              <tbody>
                                <tr>
                                  <th scope="row">
                                    {" "}
                                    {props.t("Date de publication")}
                                  </th>
                                  <td
                                    className="text-blue-500"
                                    style={{ color: "blue" }}
                                  >
                                    {selectAticle.publication_date}
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">
                                    {" "}
                                    {props.t("Date de cloture")}{" "}
                                  </th>
                                  <td
                                    className="text-red-500"
                                    style={{ color: "red" }}
                                  >
                                    {selectAticle.closure_date}
                                  </td>
                                </tr>

                                <tr>
                                  <th scope="row"> {props.t("Statut")} </th>
                                  <td className="text-red-500">
                                    {selectAticle?.published_by
                                      ? selectAticle?.published_by?.username
                                      : "Aucun"}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </TabPane>
                        <TabPane id="nav-detail" tabId="2">
                          <div>
                            <a
                              className="font-size-16 mb-3"
                              href={selectAticle.publication_link}
                              title="Ouvrir le lien"
                            >
                              <span>
                                {selectAticle.publication_link}
                                &nbsp;<i className="ri-external-link-fill"></i>
                              </span>
                            </a>
                          </div>
                          <br />
                          <div style={{ display: "flex", fontWeight: "bold" }}>
                            {" "}
                            Télécharger le fichier
                            <a
                              className="text-xs rounded"
                              href={normalizeBackendFileUrl(selectAticle.offer_file)}
                              title="Télécharger"
                            >
                              &nbsp;
                              <i
                                style={{
                                  fontSize: "30px",
                                  width: "50%",
                                  height: "50%",
                                  color: "red",
                                }}
                                className="ri-file-download-fill align-bottom"
                              ></i>
                            </a>
                          </div>
                        </TabPane>
                      </TabContent>
                    </div>
                    {!selectAticle.published && (
                      <Form
                        encType="multipart/form-data"
                        className=" bg-white rounded p-4"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                        }}
                      >
                        <div className="text-end mb-3">
                          <button
                            type="submit"
                            className="btn btn-warning mx-3"
                            disabled={publishMutation.isPending}
                          >
                            {publishMutation.isPending && (
                              <Spinner size="sm" className="me-2" />
                            )}
                            {props.t("Publier")}
                          </button>
                        </div>
                      </Form>
                    )}
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
RecrutementsDetail.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(RecrutementsDetail));
